import { useQuery } from "@apollo/client/react";
import React, { useEffect, useEffectEvent } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

import { TemplateItem } from "./TemplateItem";
import { TemplateList } from "./TemplateList";
import { GET_USERS_TEMPLATES } from "../../graphql/queries/GetUsersTemplates";
import { Banner } from "../common/Banner";
import HeadingWrapper from "../common/HeadingWrapper";
import PageTitle from "../layout/PageTitle";

export default function TypedTemplates() {
  const { data, refetch } = useQuery(GET_USERS_TEMPLATES);

  const location = useLocation();

  const checkIfAnyPresetTemplatesExist = (templates) => {
    let presetTemplatesCount = 0;

    templates?.forEach((template) => {
      if (template.isPreset === true) {
        presetTemplatesCount += 1;
      }
    });

    return presetTemplatesCount;
  };
  const onShouldRefetch = useEffectEvent(() => {
    refetch();
  });

  useEffect(() => {
    if (location?.state?.shouldRefetch) {
      onShouldRefetch();
    }
  }, [location?.state?.shouldRefetch]);

  return (
    <div>
      <PageTitle title="Templates" />
      <Banner bgStyle="bg-yellow-400">
        Please note that these are Typed Templates which only apply to
        Typed Notes.{" "}
        <strong>
          <Link to="/templates">Click here</Link>
        </strong>{" "}
        to go to Adaptive Templates for Auto-Notes.
      </Banner>
      {checkIfAnyPresetTemplatesExist(data?.user?.templates) > 0 && (
        <HeadingWrapper heading={<h3>Preset Templates</h3>} />
      )}
      <div
        id="presetTemplates"
        className="flex-1 flex flex-row flex-wrap my-4"
      >
        <TemplateList
          data={data}
          refetch={refetch}
          isForTemplateSelection={false}
          isPreset={true}
        />
      </div>
      <HeadingWrapper heading={<h3>Your Templates</h3>} />

      <h5>
        Select a template to edit it, or create a new template using
        &quot;New Template&quot;
      </h5>

      <div
        id="customTemplates"
        className="flex-1 flex flex-row flex-wrap my-4"
      >
        <TemplateItem
          name={"+ New template"}
          description={"Create your own custom template"}
          dataTestId="new-custom-template"
        />

        <TemplateList
          data={data}
          refetch={refetch}
          isForTemplateSelection={false}
          isPreset={false}
        />
      </div>
    </div>
  );
}
